import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../utils/storage";

const PublicRoutes: React.FC = () => {
  const token = getToken();
  const isAuthenticated = Boolean(token);

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoutes;



